











































































import { Vue, Component, Prop } from 'vue-property-decorator';
import {
  ResponsiveSizes,
  ComponentModel,
  BorderModel,
  ColorModel
} from '@/models';
import SelectColorComponent from './SelectColorComponent.vue';

@Component({
  components: {
    SelectColorComponent
  }
})
export default class BorderBgCss extends Vue {
  @Prop()
  size!: ResponsiveSizes;

  @Prop()
  model!: ComponentModel;

  get borderCss(): BorderModel | undefined {
    if (!this.model) return undefined;
    return this.model.getCss<BorderModel>('border', this.size);
  }

  get bgColorCss(): ColorModel | undefined {
    if (!this.model) return undefined;
    return this.model.getCss<ColorModel>('backgroundColor', this.size);
  }

  setBorderColor(color: string) {
    this.borderCss!.color.color = color;
  }

  setBorderHoverColor(color: string) {
    this.borderCss!.color.hover = color;
  }

  setBgColor(color: string) {
    this.bgColorCss!.color = color;
  }

  setBgHoverColor(color: string) {
    this.bgColorCss!.hover = color;
  }
}
